import { USA_COUNTRY_UUID } from "constants/entity";
import { AddressFieldValues } from "v2/components/AddressPicker/AddressPicker";
import { AddressData } from "v2/store/onboardingEntityApi";

/** Business address is only collected for US entities, and only sent once a street is entered. */
export const buildEntityAddressPayload = (
  countryId: string,
  address: AddressFieldValues | undefined
): AddressData | null => {
  if (countryId !== USA_COUNTRY_UUID || !address?.streetAddress) return null;

  return {
    street_address: address.streetAddress,
    street_address_line_2: address.addressLine2,
    city: address.city,
    state: address.state,
    zipcode: address.zipcode,
    country: address.country,
  };
};
